export const apiUrls = {
  posts: "/v2/posts",
  tags:"/v2/tags",
  categories: '/v2/categories'
};
